import * as types from './types'
import storage from '@/plugins/storage'

export default {
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.LOCATIONS_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.LOCATIONS_PAGE_SIZE, pageSize)
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
    storage.session.setItem(types.LOCATIONS_SORT_DIR, sortDir)
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
    storage.session.setItem(types.LOCATIONS_ORDER_BY, orderBy)
  },
  [types.SET_FILTER_OPTIONS](state, data) {
    state.filterOptions = data
  },
  [types.SET_FILTER_BY](state, filterBy) {
    state.filterBy = filterBy
    storage.local.setItem(types.LOCATIONS_FILTER_BY, filterBy)
  },
  [types.SET_LOCATION_TREE](state, data) {
    state.locationTree = data
  },
  [types.SET_LOCATIONS](state, data) {
    state.locations = data
  },
  [types.SET_LOCATION](state, data) {
    state.location = data
  },
  [types.SET_LOCATIONS_FOUND](state, data) {
    state.locationsFound = []
    if (data !== undefined && data !== null) {
      state.locationsFound = data
    }
  },
  [types.RESET_PREFERENCE_CHANGE](state, element) {
    if (state.preferences !== undefined && state.preferences !== null) {
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          state.preferences[i].changed = false
        }
      }
    }
  },
  [types.UPDATE_PREFERENCE](state, data) {
    if (state.preferences.length === 0) {
      state.preferences = []
    }
    if (state.preferences !== undefined && state.preferences !== null) {
      let found = false
      if (state.preferences.length > 0) {
        for (let i = 0; i < state.preferences.length; i++) {
          if (state.preferences[i].name === data.name) {
            state.preferences[i].value = data.value
            state.preferences[i].changed = true
            found = true
            break
          }
        }
      }
      if (found === false) {
        data.changed = true
        state.preferences.push(data)
      }
    }
  },
  [types.SET_PREFERENCES](state, data) {
    state.preferences = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        data.forEach(element => {
          element.changed = false
        })
      }
    }
    state.preferences = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/locations/mutations.js